import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-407b4d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "preview-body" }, null, -1))

import { onMounted, watch } from "vue";
import ScrollView from "../scroll-view.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'html-preview',
  props: {
  /**
   * The value to be displayed or processed by the component.
   * @type {string}
   * @required
   */
  value: {
    type: String,
    required: true,
  },
  /**
   * The height of the component, specified as a CSS string.
   * @type {string}
   * @default '100%'
   */
  height: {
    type: String,
    default: "100%",
  },
},
  setup(__props) {

const props = __props;



onMounted(() => displayPreview());

watch(
  () => props.value,
  () => {
    displayPreview();
  },
);

const displayPreview = () => {
  const previewDiv = document.getElementById("preview-body");

  if (!previewDiv) {
    return;
  }

  previewDiv.innerHTML = props.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "preview-body-container",
    style: _normalizeStyle({
      '--container-height': props.height,
    })
  }, [
    _createVNode(ScrollView, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })
  ], 4))
}
}

})